import React, { useContext } from 'react';
import './style.scss';
import { Accordion, AccordionContext, useAccordionToggle } from 'react-bootstrap';
import clsx from 'clsx';
import { Link, Text } from '@sitecore-jss/sitecore-jss-react';
import icons from '../../../../../../common/Icons.js';
import Button from '../../../../../Shared/components/controls/Button/index.js';

const AppHeaderMenuSectionAccordion = ({ data, className }) => {
  const cells = data.reduce((acc, column) => acc.concat(column.fields.items), []);

  return (
    <Accordion className={clsx('app-header-menu-section-accordion', className)}>
      {cells.map((column, index) => (
        <Cell data={column} key={index} id={index + 1} />
      ))}
    </Accordion>
  );
};

const calculateEventKey = (eventKey, currentContext) => {
  if (currentContext && currentContext.indexOf(eventKey) === -1) {
    return [...currentContext, eventKey];
  } else if (currentContext && currentContext.indexOf(eventKey) !== -1) {
    return currentContext.filter((item) => item !== eventKey);
  }
  return [eventKey];
};

const Cell = ({ data, id }) => {
  const { title, items, link } = data?.fields;
  const needExpand = items?.length > 0 && items?.some((item) => !!item.fields.link?.value?.href);
  var eventKey = id;
  const currentContext = useContext(AccordionContext);
  const isActive = currentContext?.indexOf(eventKey) > -1 || false;

  const onClick = useAccordionToggle(calculateEventKey(eventKey, currentContext));

  return (
    <div className={clsx('ah-msa-item', isActive && needExpand && 'ah-msa-item-active')}>
      <div className="ah-msa-item-front" onClick={onClick}>
        <CellTitle title={title} link={link} hasNested={needExpand} />
        {needExpand && <img src={icons.chevronDownBlue} className="ah-msa-item-icon" />}
      </div>
      {needExpand && (
        <Accordion.Collapse eventKey={isActive ? currentContext : ''}>
          <ul className="ah-msa-item-back">
            {items.map((item, index) => (
              <CellElement data={item} key={index} />
            ))}
          </ul>
        </Accordion.Collapse>
      )}
    </div>
  );
};

const CellTitle = ({ link, title, hasNested }) => {
  if (!link?.value?.href) {
    return (
      <div className="ah-msa-item-front-title">
        <Text field={title} />
      </div>
    );
  }
  if (!hasNested) {
    return (
      <Link field={link} className="ah-msa-item-front-title">
        <Text field={title} />
      </Link>
    );
  }
  return (
    <div className="ah-msa-item-front-title">
      <Link
        field={link}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Text field={title} />
      </Link>
    </div>
  );
};

const CellElement = ({ data }) => {
  if (!data.fields.link?.value?.href) return null;
  const linkStyling = !!data.fields.callToAction?.value;

  return (
    <li className="ah-msa-link">
      {linkStyling ? (
        <Button link={data.fields.link} variant="text" color="primary" arrow="right" />
      ) : (
        <Link field={data.fields.link} className="ah-msa-link-link" />
      )}
    </li>
  );
};

export default AppHeaderMenuSectionAccordion;
